"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useBroadcastTimeRange = void 0;
var _utils = require("../../utils");
/**
 * This hook is returns the duration from when the broadcast is to start and when the broadcast is to end.
 * @param serverTimeDelta
 * @param broadcast
 * @returns {{serverTimeToStart: (*|number), serverTimeToEnd: (*|number)}}
 */
var useBroadcastTimeRange = exports.useBroadcastTimeRange = function useBroadcastTimeRange(_ref) {
  var serverTimeDelta = _ref.serverTimeDelta,
    broadcast = _ref.broadcast;
  var _broadcast$startOn = broadcast.startOn,
    startOn = _broadcast$startOn === void 0 ? 0 : _broadcast$startOn,
    _broadcast$endOn = broadcast.endOn,
    endOn = _broadcast$endOn === void 0 ? 0 : _broadcast$endOn;
  var serverStartTime = (0, _utils.getServerTime)(startOn, serverTimeDelta);
  var serverEndTime = (0, _utils.getServerTime)(endOn, serverTimeDelta);
  var serverTimeToStart = (0, _utils.getSecondsTo)(serverStartTime);
  var serverTimeToEnd = (0, _utils.getSecondsTo)(serverEndTime);
  return {
    serverTimeToStart: serverTimeToStart,
    serverTimeToEnd: serverTimeToEnd
  };
};